// @ts-nocheck
/* eslint-disable no-continue */
// LIBRARY
import React from 'react';
import { Row, Col, Spin, Alert } from 'antd';
import PropTypes from 'prop-types';
import { fetchLabResultExamItems } from 'services/lab_result/result';
import { fetchRequestSpecimenToProcess } from 'services/phlebo/specimenTracking';
import { UserAccessContext } from 'context/userAccess';
import { EditResultContext } from 'context/editResultContext';

// CUSTOM MODULES
import PrintLabResult from 'modules/main/lab_result/print_result';
import LabRequestDetails from 'shared_components/patient_info';
import TableResults from './result_table';
import PatientName from './patientname';
import Actions from './actions';
import PatientComment from './patientcomment';

// CSS
import './edit_result.css';

class EditResult extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			results: {},
			formatedResults: [],
			patientOtherInfo: {},
			isDisplayPrint: false,
			// isResultsTouched: false,
			isResultsTouched: true, // as per sir canil reverted to always be enabled - 20230914 
			selectedIresults: [],
			tableFormValues: {}, // added to catch exams from editable table
		};

		this.resultTable = React.createRef();
		this.resultRemarks = React.createRef();
	}

	componentDidMount() {
		const { examDetails, patientInfo } = this.props;
	
		this.setState({ isLoading: true }, async () => {
			const results = await fetchLabResultExamItems(examDetails.sampleSpecimenID);
			console.log("🚀 ~ EditResult ~ componentDidMount ~ results:", results)
			const patientSpecimens = await fetchRequestSpecimenToProcess(patientInfo.requestID);
			const formatedResults = this.recontructExamItems(results.resultValues);

			const {
				hospitalRequestID,
				physician,
				bed,
				visit,
				chargeSlip,
				officialReceipt,
				comment,
				location,
			} = patientSpecimens;

			const patientOtherInfo = {
				hospitalID: hospitalRequestID || '-',
				physician: physician
					? `${physician.namePrefix} ${physician.givenName} ${physician.lastName}`.toUpperCase()
					: '-',
				bed: bed || '-',
				visit: visit || '-',
				chargeSlip: chargeSlip || '-',
				receipt: officialReceipt || '-',
				comment: comment || '-',
				location: location !== undefined ? location.name.toString().toUpperCase() : '-',
			};

			this.setState({
				results,
				formatedResults,
				patientOtherInfo,
				isLoading: false,
			});
		});
	}

	async componentDidUpdate(prevProps) {
		const { examDetails } = this.props;

		if (examDetails.sampleSpecimenID !== prevProps.examDetails.sampleSpecimenID) {
			// eslint-disable-next-line react/no-did-update-set-state
			this.setState(
				{
					isLoading: true,
					results: { resultValues: [], remarks: null },
				},
				async () => {
					const results = await fetchLabResultExamItems(examDetails.sampleSpecimenID);
					const formatedResults = this.recontructExamItems(results.resultValues);

					// eslint-disable-next-line react/no-did-update-set-state
					this.setState({
						results,
						formatedResults,
						isLoading: false,
						isResultsTouched: false
					});
				},
			);
		}
		
	}

	// remove this at your own risk
	setTableResults = tableResults => {
		this.setState({
			tableFormValues: tableResults,
		});
	};

	getFormValues = async () => {
		const remarks = await this.resultRemarks.getRemarks();
		// const form = this.resultTable.getFormValues();
		const form = this.state.tableFormValues;

		return { form: { ...form }, remarks };
	};

	onChangeResult = () => {
		this.setState({
			isResultsTouched: true,
		});
	};

	onSaveSuccess = () => {
		const { examDetails } = this.props;

		this.setState({ isLoading: true }, async () => {
			const results = await fetchLabResultExamItems(examDetails.sampleSpecimenID);
			const formatedResults = this.recontructExamItems(results.resultValues);

			// eslint-disable-next-line react/no-did-update-set-state
			this.setState({
				results,
				formatedResults,
				isLoading: false,
				isResultsTouched: false,
			});
		});
	};

	onPrint = () => {
		this.setState({ isDisplayPrint: true });
	};

	// Private Function
	recontructExamItems = results => {
		const newExamItems = [];
		let currentHeader = null;

		if (results) {
			// eslint-disable-next-line no-plusplus
			for (let i = 0; i < results.length; i++) {
				if (results[i].examRequestItemGroup === '' || results[i].examRequestItemGroup === null) {
					newExamItems.push(results[i]);

					continue;
				}

				if (currentHeader !== results[i].examRequestItemGroup) {
					currentHeader = results[i].examRequestItemGroup;
					currentHeader === '1'
						? console.log('1')
						: newExamItems.push({
								examItemName: currentHeader,
								examItemID: `header-${currentHeader}`,
						  });
					newExamItems.push({ ...results[i], isChild: true });

					continue;
				}

				newExamItems.push({ ...results[i], isChild: true });
			}
		}
		return newExamItems;
	};

	handleSelectResults = results => {
		this.setState({
			selectedIresults: results,
		});
	};
	alertDescription = (
		<div className="alert-description">
			Press <code>Ctrl + Enter</code> keys to view previous result.
		</div>
	);
	render() {
		const {
			results,
			isLoading,
			formatedResults,
			isDisplayPrint,
			isResultsTouched,
			patientOtherInfo,
			selectedIresults,
			tableFormValues,
		} = this.state;
		
		const { patientInfo, examDetails } = this.props;
		const headerDetails = {
			patientInfo: patientInfo,
			specimenID: examDetails.specimenID,
			sampleSpecimenID: examDetails.sampleSpecimenID,
			specimenStatus: examDetails.specimenStatus,
			selectedSectionID: examDetails.sectionID,
		};
		
		const isApproved = (results.status === 'Approved') ? true : false;

		return (
			<EditResultContext.Provider value={{ selectedIresults, onChangeResult: this.onChangeResult, }}>
			<Row>
				<Col xs={24} sm={24} md={24} lg={6} xl={6}>
					<LabRequestDetails patientInfo={patientInfo} patientOtherInfo={patientOtherInfo} />
				</Col>
				<Col xs={24} sm={24} md={24} lg={18} xl={18} className="patient-info-content">
					<PatientName
						patientInfo={patientInfo}
						sampleSpecimenID={examDetails.sampleSpecimenID || null}
						specimenStatus={results.status}
						showIreportButton={true}
						getSelectedResults={this.handleSelectResults}
						isApproved={isApproved}
						specimenStatusID={results.statusID || ''}
					/>
					<Spin spinning={isLoading}>
						<TableResults
							results={results.resultValues || []}
							resultStatus={results.status || ''}
							formatedResults={formatedResults}
							onChangeResult={this.onChangeResult}
							changeInitialValue={this.changeInitialValue}
							headerDetails={headerDetails}
							selectedIresults={selectedIresults}
							tableFormValeus={tableFormValues}
							setTableResults={this.setTableResults}
							recontructExamItems={this.recontructExamItems}
							specimenStatusID={results.statusID || ''}
						/>
						<br />
						<Alert message="Tip" type="info" description={this.alertDescription} showIcon />
					</Spin>
					<PatientComment
						// wrappedComponentRef={(inst) => this.resultRemarks = inst}
						ref={inst => (this.resultRemarks = inst)}
						remarks={results.remarks || null}
						resultStatus={results.status || ''}
						onChangeResult={this.onChangeResult}
					/>
					<UserAccessContext.Consumer>
						{({ userAccess }) =>
							userAccess.result.update && (
								<Actions
									getLabResultFormValues={this.getFormValues}
									onSaveSuccess={this.onSaveSuccess}
									onPrint={this.onPrint}
									resultStatus={results.status || ''}
									isResultsTouched={isResultsTouched}
									specimenStatusID={results.statusID || ''}
									results={results}
									headerDetails={headerDetails}
									// hasEmptyReleasedResult={hasEmptyReleasedResult}
								/>
							)
						}
					</UserAccessContext.Consumer>
					<PrintLabResult
						sampleID={examDetails.sampleSpecimenID || null}
						requestID={patientInfo.requestID || null}
						visible={isDisplayPrint}
						onClose={() => this.setState({ isDisplayPrint: false })}
						resultStatus={results.status || ''}
						onSaveSuccess={this.onSaveSuccess}
						getLabResultFormValues={this.getFormValues}
						sectionName={examDetails.sectionName}
						specimenStatusID={examDetails.specimenStatusID || ''}
					/>
				</Col>
			</Row>
			</EditResultContext.Provider>
		);
	}
}

EditResult.propTypes = {
	patientInfo: PropTypes.shape({
		requestID: PropTypes.string,
	}).isRequired,
	examDetails: PropTypes.shape({
		sampleSpecimenID: PropTypes.string,
		specimenStatus: PropTypes.string,
		// specimenStatusID: PropTypes.string
	}).isRequired,
};

export default EditResult;
